<template>
    <v-server-table url="/api/admin/settings/table" :columns="columns" :options="options" class="trigger" ref="table">
        <template slot="name" slot-scope="props">
            <router-link :to="{ name: 'admin.settings.edit', params: { id: props.row.id }}">{{ uLang('app.' + props.row.name) }}</router-link>
        </template>
    </v-server-table>
</template>

<script>
    import Actions from '~/components/tables/admin/setting/actions'
    import { TableMixin } from '~/mixins'
    export default {
        name: 'index',
        mixins: [ TableMixin ],
        props: {
            rowsPerPage: {
                type: String,
                default: "15"
            }
        },
        data () {
            return {
                columns: ['name', 'actions'],
                templates: {
                    actions: Actions,
                },
                options: {
                    headings: {
                        name: this.uLang('app.name'),
                        actions: this.uLang('app.actions'),
                    },
                },
            }
        },
        created: function () {
            //set filter placeholder column name lowercase
            setTimeout(function () {
                [].forEach.call(
                    document.querySelectorAll('.VueTables__filters-row th input'),
                    function(el){
                        let placeholder = el.placeholder.toLowerCase();
                        el.placeholder = placeholder.charAt(0).toUpperCase() + placeholder.slice(1);
                    }
                );
            }, 15);
        },
        watch: {
            rowsPerPage(newValue) {
                this.$refs.table.setLimit(Number.parseInt(newValue, 10));
                this.$refs.table.refresh();
            }
        }
    }
</script>

<style lang="css" scoped>
</style>